import { createSelector } from 'reselect';
import { getMachine } from './getMachine';
import { getMachineERPResources } from './getMachineERPResources';

/** Replaces master `machine.erpResources` — all resourceIds from GET_ERP_RESOURCES. */
export const getAssociatedErpResourceIds = createSelector(
  [getMachineERPResources],
  (machineERPResources) => {
    return machineERPResources.map((resource) => {
      return resource.resourceId;
    });
  }
);

// TODO: resource.machineRef is being deprecated as the machine→ERP link.
// Replace with machineSettings.laborResourceId once the new relationship is live.
/** Direct machineRef match from GET_ERP_RESOURCES (API source for machine.erpResourceId). */
export const getMachineErpResourceIdFromApi = createSelector(
  [getMachine, getMachineERPResources],
  (machine, erpResources) => {
    const machineErpResource = erpResources.find((resource) => {
      return resource.machineRef === machine?.machineRef;
    });

    return machineErpResource?.resourceId ?? null;
  }
);
